var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"edu-title",class:_vm.blok.classes},[_vm._v(_vm._s(_vm.blok.title))])}
var staticRenderFns = []

export { render, staticRenderFns }